export type AuthUser = {
  sub: string
  email: string
}

export default function () {
  return useState<AuthUser | undefined>('user-session-state', () => undefined)
}
